import React from 'react';
import styled from 'styled-components';

import Checkbox from 'shared/components/Checkbox';
import { SourceSelectionCellProps } from './types';
import { SOURCE_COUNT_LIMIT } from '../../constants';

const StyledContainer = styled.div`
  display: flex;
`;

const SourceSelectionCell = ({
  value: sourceId,
  selectedSources = [],
}: SourceSelectionCellProps) => {
  const isSelected = !!selectedSources.find(({ id }) => id === sourceId);
  return (
    <StyledContainer>
      <Checkbox
        isDisabled={!isSelected && selectedSources.length >= SOURCE_COUNT_LIMIT}
        isChecked={isSelected}
      />
    </StyledContainer>
  );
};

export default SourceSelectionCell;
